import { Country } from '@afterpaytouch/portal-api/types'
import { Route } from '../../config/router'
import { useAppDispatch, updateRegistrationStatus, useAppRouter } from '../../state'
import { RegistrationStatus } from '../../model/registration'
import { useIdentityVerifyRedirect } from '../useIdentityVerifyRedirect/useIdentityVerifyRedirect'
import { isCountryNeedsSoftIdAttempt } from '../../model'
import { useAmplitudeWithEnduringEventProperties } from '../../integrations/amplitude'
import { TrackingEvent } from '../../model/amplitude'
import { useUkRegFlags } from '../useUkRegFlags/useUkRegFlags'

export const usePostRegistrationRedirect = (): {
  redirectAfterRegistration: (countryCode?: Country) => Promise<void>
} => {
  const { push } = useAppRouter()
  const dispatch = useAppDispatch()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()
  const { verifyAndHandleOutcome } = useIdentityVerifyRedirect()
  const { isUkRegsServicingFlagEnabled } = useUkRegFlags()

  const redirectAfterRegistration = async (countryCode?: Country): Promise<void> => {
    dispatch(updateRegistrationStatus(RegistrationStatus.Completed))

    // NOTE: countryCode comes from Redux consumer state (consumer?.countryCode) which
    // defaults to AU and may not be hydrated post-registration. This country check
    // may be unreliable for fresh GB registrations until account hydration completes.
    if (isUkRegsServicingFlagEnabled && countryCode === Country.GB) {
      push(Route.PROFILE_CREATED)
      return
    }

    if (isCountryNeedsSoftIdAttempt(countryCode)) {
      logEvent(TrackingEvent.IDENTITY_VERIFY_FIRST_ATTEMPT)
      await verifyAndHandleOutcome({ showToastBody: true })
    } else {
      push(Route.LOGGED_IN)
    }
  }

  return { redirectAfterRegistration }
}
